/**
 * Cart Badge Update Functionality
 * Dynamically updates the cart badge counter in the navigation
 */
(function() {
  'use strict';

  /**
   * Update cart badge with current item count
   * @param {number} itemCount - Number of items in cart
   */
  function updateCartBadge(itemCount) {
    const desktopBadges = document.querySelectorAll('#cart-badge-desktop');
    const mobileBadges = document.querySelectorAll('#cart-badge-mobile');
    const allBadges = [...desktopBadges, ...mobileBadges];

    allBadges.forEach(function(badge) {
      if (itemCount > 0) {
        badge.textContent = itemCount;
        badge.classList.remove('empty');
        badge.style.display = 'flex';
      } else {
        badge.classList.add('empty');
        badge.style.display = 'none';
      }
    });
  }

  /**
   * Fetch current cart and update badge
   */
  async function fetchAndUpdateCartBadge() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const cart = await response.json();
        updateCartBadge(cart.item_count);
      }
    } catch (error) {
      console.error('[Cart Badge] Error fetching cart:', error);
    }
  }

  /**
   * Intercept fetch requests to update badge on cart operations
   */
  function interceptCartOperations() {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      
      // Check if it's a cart-related request
      if (typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      )) {
        return originalFetch.apply(this, args).then(async function(response) {
          // Clone the response to read it
          const clonedResponse = response.clone();
          
          try {
            const data = await clonedResponse.json();
            if (data.item_count !== undefined) {
              updateCartBadge(data.item_count);
            } else {
              // Fallback: fetch the full cart
              fetchAndUpdateCartBadge();
            }
          } catch (error) {
            // Response might not be JSON, fetch the cart
            fetchAndUpdateCartBadge();
          }
          
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };

    // Also intercept jQuery AJAX if available
    if (window.jQuery) {
      const originalAjax = jQuery.ajax;
      jQuery.ajax = function(url, options) {
        if (typeof url === 'object') {
          options = url;
          url = options.url;
        }
        
        if (typeof url === 'string' && (
          url.includes('/cart/add') ||
          url.includes('/cart/update') ||
          url.includes('/cart/change') ||
          url.includes('/cart/clear')
        )) {
          const originalSuccess = options && options.success;
          if (options) {
            options.success = function(data, textStatus, jqXHR) {
              if (data && data.item_count !== undefined) {
                updateCartBadge(data.item_count);
              } else {
                fetchAndUpdateCartBadge();
              }
              if (originalSuccess) {
                originalSuccess.apply(this, arguments);
              }
            };
          }
        }
        
        return originalAjax.call(this, url, options);
      };
    }
  }

  /**
   * Initialize cart badge
   */
  function init() {
    // Intercept cart operations
    interceptCartOperations();

    // Listen for custom cart update events (if other scripts dispatch them)
    document.addEventListener('cart:updated', function(event) {
      if (event.detail && event.detail.item_count !== undefined) {
        updateCartBadge(event.detail.item_count);
      } else {
        fetchAndUpdateCartBadge();
      }
    });

    // Refresh badge when page becomes visible (in case cart was updated in another tab)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        fetchAndUpdateCartBadge();
      }
    });

    // Update badge immediately on load
    fetchAndUpdateCartBadge();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export for external use
  window.updateCartBadge = updateCartBadge;
})();
